import { Component, OnInit, ElementRef, Renderer2, ViewChild, OnDestroy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { ActionCoCalculatorModel, ActionCoCalculatorMission, ActionCoMissionGroup, ActionCoMissionQuestion, ActionCoMissionPDCGrouped, ActionCoMissionProperty, BObjectModel, ActionCoCollaborateurMission, BObjectBody, PropertyGroup, PropertyData, ActionCoCalculatorTab, Corporation } from '../../../models';
import { HttpService, CoreService, QueovalDateService } from '../../../services';
import { ToastService } from '../../../toast';
import { ActionCoService } from '../action-co-services/action-co.service';
import { ActionCoCalculatorService } from '../action-co-services/action-co-calculator.service';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { setAlertMNG } from '../../../utilities';
import { map } from 'rxjs/operators';
import { forkJoin, Observable } from 'rxjs';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-action-co-calculateur',
  templateUrl: './action-co-calculator.component.html',
  styleUrls: ['./action-co-calculator.component.css', '../action-co-card.component.css', '../action-co-action/action-co-action.component.css',]
})

export class ActionCoCalculatorComponent implements OnInit, OnDestroy {
  public displayMode: string = 'VIEW';

  public missionToDelete: ActionCoCalculatorMission;
  public indexToDelete: number;

  public deleteMission: boolean = false;
  public reinitMission: boolean = false;
  public savingNewObligation: boolean = false;

  public NewObligationLine: ActionCoMissionPDCGrouped = new ActionCoMissionPDCGrouped();

  public fileEvent: any = null;
  public modalImport: NgbModalRef;
  public modalDelete: NgbModalRef;
  public modalReinitialisation: NgbModalRef;

  public importingConfig: boolean = false;

  public newModelName: string = '';
  public emptyModelName: boolean = false;

  public focusedTab: ActionCoCalculatorMission;
  public focusedTabIndex: number;

  public lastPopoverModelTab: NgbPopover;

  @ViewChild('ModalImport', { static: false }) ModalImport: ElementRef;
  @ViewChild('ModalConfirmReinitialisation', { static: false }) ModalConfirmReinitialisation: ElementRef;
  @ViewChild('ModalConfirmDeleteMission', { static: false }) ModalConfirmDeleteMission: ElementRef;

  @ViewChild('popoverPlusButton', { static: false }) popoverPlusButton: NgbPopover;
  constructor(
    protected http: HttpService,
    protected httpClient: HttpClient,
    public indParam: CoreService,
    protected qDateService: QueovalDateService,
    public sanitizer: DomSanitizer,
    public toast: ToastService,
    protected actionCoService: ActionCoService,
    private renderer: Renderer2,
    protected modalService: NgbModal,
    private router: Router,
    public calculatorService: ActionCoCalculatorService
  ) { }

  //#region CYCLE DE VIE
  public ngOnInit(): void {
    this.calculatorService.InitVariables();
    this.calculatorService.bObjectModel.IdDonneePere = this.actionCoService.Model.Customer.Id;
    this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/GET_LISTS_MISSIONS_NON_CLOTUREES/${this.actionCoService.Model.Customer.Id}|${this.actionCoService.Model.idActionCo}|${this.actionCoService.Model.TypeDevis}`).subscribe(
      (result: ActionCoCalculatorModel) => {
        let indexLinkedMissions = -1;
        result.Tabs.forEach((tab: ActionCoCalculatorTab) => {
          if (tab.Linked) {
            indexLinkedMissions++;
            this.calculatorService.LinkedMissions.push(this.SetTabToMission(tab));
            this.GetMissionDatas(indexLinkedMissions).subscribe((data) => {
              if (data.index == 0) this.calculatorService.SetDefaultMission();
            });
          } else {
            this.calculatorService.UnlinkedMissions.push(this.SetTabToMission(tab));
          }
        });
      });
  }

  public ngOnDestroy(): void {
    (this.modalImport as NgbModalRef | null) = null;
    (this.modalDelete as NgbModalRef | null) = null;
  }
  //#endregion
  //#region METHODES PUBLIQUES
  //#region navigation entre les onglets
  public OnChangeMission(mission: ActionCoCalculatorMission, preventChange: boolean) {
    if (!preventChange) {
      if (this.calculatorService.lockTabs) return;

      if (this.displayMode === 'CONFIG' && mission.Groups.length === 0) {
        this.calculatorService.AddGroup(mission);
        mission.Groups[0].Displayed = true;
        mission.Groups[0].Questions[0].Displayed = true;
      }
      this.RefreshGlobalInformationGroupLabel(mission);
      this.calculatorService.OnChangeMission(mission.CodeBo, mission.Ident);
      // this.calculatorService.Mission = mission;
    }
  }

  public OpenModalDeleteMission(mission: ActionCoCalculatorMission, index: number): void {
    if (this.calculatorService.lockTabs) return;
    this.missionToDelete = mission;
    this.indexToDelete = index;
    this.modalDelete = this.modalService.open(this.ModalConfirmDeleteMission, { size: 'q-long', centered: true });
  }

  public DeleteMission() {

    this.deleteMission = true;

    //#region Suppression du projet de l'onglet
    if (this.calculatorService.UnlinkedMissions) {
      this.calculatorService.UnlinkedMissions.push(JSON.parse(JSON.stringify(this.missionToDelete)));
    } else {
      this.calculatorService.UnlinkedMissions = [JSON.parse(JSON.stringify(this.missionToDelete))];
    }
    // si l'onglet supprimé est l'onglet actif, l'onglet actif devient l'onget à l'index 0
    if (this.calculatorService.Mission && this.calculatorService.Mission.CodeBo && this.missionToDelete && this.missionToDelete.CodeBo && this.calculatorService.Mission.CodeBo === this.calculatorService.Mission.CodeBo) {
      this.calculatorService.SetDefaultMission();
    }

    this.calculatorService.LinkedMissions.splice(this.indexToDelete, 1);
    //#endregion

    if (this.missionToDelete.Ident && this.missionToDelete.Ident != "0") {
      // Suppression en BDD du projet deja créé
      const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
      model.Mode = 'DELETE_MISSION';
      model.Client = this.actionCoService.Model.Customer;
      model.Mission.Ident = this.missionToDelete.Ident;

      this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
        (result: ActionCoCalculatorModel) => {
          this.deleteMission = false;
          this.actionCoService.OnMissionAdd();
          this.calculatorService.CalculTotalAmount();
          this.modalDelete.close();
          this.displayMode = 'VIEW';
        });
    }
    else {
      this.deleteMission = false;
      this.calculatorService.CalculTotalAmount();
      this.modalDelete.close();
      this.displayMode = 'VIEW';
    }
  }

  public OnAddingTab(mission: ActionCoCalculatorMission, boModel: string, index: number): void {
    if (this.calculatorService.LinkedMissions) {
      this.calculatorService.LinkedMissions.push(mission);
    } else {
      this.calculatorService.LinkedMissions = [mission];
    }
    this.calculatorService.UnlinkedMissions.splice(index, 1);
    this.GetMissionDatas(this.calculatorService.LinkedMissions.length - 1, boModel).subscribe(() => {
        this.OnChangeMission(this.calculatorService.LinkedMissions[this.calculatorService.LinkedMissions.length - 1], false);
    });
  }

  public OnMouseEnterOnUnlinkedTab(popoverModels: NgbPopover, mission: ActionCoCalculatorMission, index: number): void {
    if (this.lastPopoverModelTab && this.focusedTab && this.focusedTab.CodeBo != mission.CodeBo) {
      this.lastPopoverModelTab.close();
    }
    this.focusedTab = mission;
    this.focusedTabIndex = index;
    popoverModels.open();
  }
  //#endregion

  //#region méthodes des boutons d'entête

  public SwitchDisplayMode(): void {
    this.displayMode = this.displayMode === 'CALCULATE' ? 'VIEW' : 'CALCULATE';
    this.RefreshGlobalInformationGroupLabel(this.calculatorService.Mission);
  }

  public OnClickConfig(): void {
    if (this.displayMode !== 'CONFIG' && this.calculatorService.Mission.Groups.length === 0) {
      this.calculatorService.AddGroup(this.calculatorService.Mission);
      this.calculatorService.Mission.Groups[0].Displayed = true;
      this.calculatorService.Mission.Groups[0].Questions[0].Displayed = true;
    }
    this.displayMode = this.displayMode === 'CONFIG' ? 'VIEW' : 'CONFIG';
    this.RefreshGlobalInformationGroupLabel(this.calculatorService.Mission);
  }

  public SaveMission(): void {
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel;
    model.Mission = JSON.parse(JSON.stringify(this.calculatorService.Mission));
    if (!model.Mission)
      model.Mission = new ActionCoCalculatorMission();
    if (!model.Mission.Groups)
      model.Mission.Groups = new Array<ActionCoMissionGroup>();
    model.Mission.Groups.push(JSON.parse(JSON.stringify(this.calculatorService.Mission.globalInformationGroup)));
    model.Client = this.actionCoService.Model.Customer;
    model.Ident = this.actionCoService.Model.idActionCo;

    this.calculatorService.Mission.loadingDatas = true;
    this.calculatorService.lockTabs = true;

    this.calculatorService.savingMission = true;
    model.Mode = this.displayMode === 'CALCULATE' ? 'UPDATE_MISSIONPDC' : 'SAVE_MISSION'
    this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
      (result: ActionCoCalculatorModel) => {
        this.calculatorService.savingMission = false;
        this.calculatorService.Mission.loadingDatas = false;
        this.calculatorService.lockTabs = false;
        if (!result.HasBlockingAlert) {
          this.AffectGlobalInformationGroup(result);

          if (!result.HasSomeError) {
            result.Mission.CodeBo = this.calculatorService.Mission.CodeBo;
            this.calculatorService.Mission = result.Mission;
            //this.calculatorService.AffectRequiredMissionProperties(this.calculatorService.Mission);
            this.OnChangeMission(this.calculatorService.Mission, false);
            this.actionCoService.OnMissionAdd();
          }
        }
        else {
          this.calculatorService.Mission.Ident = result.Mission.Ident;
          this.OnChangeMission(this.calculatorService.Mission, false);
          this.actionCoService.OnMissionAdd();
        }
        this.calculatorService.CalculTotalAmount();
      });
  }

  public ReinitMission(): void {
    if (this.displayMode === 'CALCULATE' && this.calculatorService.Mission.BoName != 'BO_MCAC') {

    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel(); //JSON.parse(JSON.stringify(this.model));
    model.Mode = "DELETE_MISSIONPDC";
    model.Mission = JSON.parse(JSON.stringify(this.calculatorService.Mission));
    if (!model.Mission)
      model.Mission = new ActionCoCalculatorMission();
    if (!model.Mission.Groups)
      model.Mission.Groups = new Array<ActionCoMissionGroup>();
    model.Mission.Groups.push(JSON.parse(JSON.stringify(this.calculatorService.Mission.globalInformationGroup)));

    model.Client = this.actionCoService.Model.Customer;
    model.Ident = this.actionCoService.Model.idActionCo;
    this.calculatorService.Mission.loadingDatas = true;
    this.calculatorService.lockTabs = true;

    this.reinitMission = true;

      this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).subscribe(
        (result: ActionCoCalculatorModel) => {
          this.modalReinitialisation.close();
          this.AffectGlobalInformationGroup(result);
          this.reinitMission = false;
          this.calculatorService.Mission.loadingDatas = false;
          this.calculatorService.lockTabs = false;
          if (!result.HasSomeError) {
            result.Mission.CodeBo = this.calculatorService.Mission.CodeBo;
            this.calculatorService.Mission = result.Mission;
            this.OnChangeMission(this.calculatorService.Mission, false);
          }
          this.calculatorService.CalculTotalAmount();
        });
    }
    else {
      this.calculatorService.CalculTotalAmount();
      this.modalReinitialisation.close();
    }
  }

  public ExportConfig(): void {
    this.http.getHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/EXPORT_DATA_CONFIG/0`).subscribe(
      (result: ActionCoCalculatorModel) => {
        if (!result.HasError && result.StrXml) {
          const filename: string = "configfile.xml";
          const pom: HTMLAnchorElement = document.createElement('a');
          const bb: BlobPropertyBag = new Blob([result.StrXml], { type: 'text/plain' });

          pom.setAttribute('href', window.URL.createObjectURL(bb));
          pom.setAttribute('download', filename);

          pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
          pom.draggable = true;
          pom.classList.add('dragout');

          pom.click();
        }
      });
  }

  public ImportConfig(): void {
    if (!this.fileEvent || !this.fileEvent.target || !this.fileEvent.target.files || this.fileEvent.target.files.length < 1 || this.fileEvent.target.value == '') {
      return;
    }
    const file = this.fileEvent.target.files[0];
    const config: any = {
      responseType: 'arraybuffer' as 'arraybuffer',
      observe: 'response'
    };
    const formData: FormData = new FormData();

    formData.append('file', file, file.name);
    formData.append('mode', 'SAVE');
    formData.append('token', this.indParam.AppParams.token);
    this.importingConfig = true;
    this.httpClient.post(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/ImportXml/`, formData, config).subscribe(
      (result: any) => {
        this.importingConfig = false;
        //this.loaded = true;
        const res: ActionCoCalculatorModel = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(result.body)));
        if (!res.HasSomeError) {
          (this.modalImport as NgbModalRef).close();
          this.ngOnInit();
        }
        setAlertMNG(this.indParam, this.router, this.toast, res);
      });

  }

  public SaveBoModel(): void {
    if (!this.newModelName) {
      this.emptyModelName = true;
      this.toast.showAlertToast('Veuillez renseigner le nom du model');
      return;
    }
    const model: BObjectModel = new BObjectModel();
    model.Body = new BObjectBody();
    model.Body.SelectedGroupsList = new Array<PropertyGroup>();
    const propertiesGroup: PropertyGroup = new PropertyGroup();
    propertiesGroup.DataList = new Array<PropertyData>();
    this.calculatorService.Mission.MissionsProperties.forEach((prop: ActionCoMissionProperty) => {
      propertiesGroup.DataList.push(JSON.parse(JSON.stringify(prop.Value)));
    });
    this.calculatorService.Mission.Groups.forEach((group: ActionCoMissionGroup) => {
      group.Questions.forEach((quest: ActionCoMissionQuestion) => {
        quest.Properties.forEach((prop: ActionCoMissionProperty) => {
          propertiesGroup.DataList.push(JSON.parse(JSON.stringify(prop.Value)));
        });
      });
    });
    this.calculatorService.Mission.globalInformationGroup.Questions.forEach((quest: ActionCoMissionQuestion) => {
      quest.Properties.forEach((prop: ActionCoMissionProperty) => {
        propertiesGroup.DataList.push(JSON.parse(JSON.stringify(prop.Value)));
      });
    });

    model.Body.SelectedGroupsList.push(propertiesGroup);
    model.Mode = 'SAVE_MODEL';
    model.ModelName = this.newModelName;
    model.IdentBO = this.calculatorService.Mission.CodeBo;
    this.indParam.showSplash(true);
    this.http.postHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/`, model).subscribe
      ((data: BObjectModel) => {
        if (!data.HasSomeError) {
          this.http.getHttp<BObjectModel>(`${this.indParam.AppParams.apiUrl}api/bobject/getData/GET_MODELS/${this.calculatorService.Mission.CodeBo}/`).subscribe
            ((data: BObjectModel) => {
              if (!data.HasSomeError) {
                this.calculatorService.Mission.BoModels = data.Header.SavedModels;
              }
              this.indParam.showSplash(false);
              this.popoverPlusButton.close();
            });

        } else {
          this.indParam.showSplash(false);
          this.popoverPlusButton.close();
        }
      });
  }

  public OpenModalImport(e: any): void {
    this.fileEvent = e;
    this.modalImport = this.modalService.open(this.ModalImport, { size: 'q-long', centered: true });
    this.modalImport.result.finally(() => {
      this.fileEvent.target.value = '';
    });
  }

  public OpenModalReinitialisation(): void {
    this.modalReinitialisation = this.modalService.open(this.ModalConfirmReinitialisation, { size: 'q-long', centered: true });
  }
  //#endregion

  //#endregion

  private RefreshGlobalInformationGroupLabel(mission: ActionCoCalculatorMission): void {
    switch (this.displayMode) {

      case 'CALCULATE':
        mission.globalInformationGroup.Questions[0].Label = 'Nouvelle obligation manuelle';
        mission.globalInformationGroup.Questions[0].Description = '';
        break;
      case 'VIEW':
      case 'CONFIG':
        mission.globalInformationGroup.ShowCalculGroup = mission.globalInformationGroup.Questions[0].Properties.length > 0;
        mission.globalInformationGroup.Questions[0].Label = '';
        mission.globalInformationGroup.Questions[0].Description = '';
        break;
    }
  }

  private SetTabToMission(tab: ActionCoCalculatorTab): ActionCoCalculatorMission {
    const result: ActionCoCalculatorMission = new ActionCoCalculatorMission();
    result.TabLabel = tab.TabLabel;
    result.CodeBo = tab.CodeBo;
    result.Ident = tab.Ident;
    result.IdRelation = tab.IdRelation;
    result.Info = tab.Info;
    result.IsProjet = tab.IsProjet;
    result.BoModels = tab.BoModels;
    result.SelectedBoModel = tab.SelectedBoModel;
    result.Linked = tab.Linked;
    return result;
  }

  private GetMissionDatas(index: number, boModel: string = ''): Observable<{ mission: ActionCoCalculatorModel, index: number }> {
    this.calculatorService.LinkedMissions[index].loadingDatas = true;
    this.calculatorService.lockTabs = true;
    const model: ActionCoCalculatorModel = new ActionCoCalculatorModel();
    model.Mode = 'GET_MISSION';
    model.Mission = this.calculatorService.LinkedMissions[index];
    model.Client = new Corporation();
    model.Client.Id = this.actionCoService.Model.Customer.Id;
    model.Mission.SelectedBoModel = boModel;
    return this.http.postHttp<ActionCoCalculatorModel>(`${this.indParam.AppParams.apiUrl}api/ActionCo/Calculator/`, model).pipe(
      map((result: ActionCoCalculatorModel) => {
        this.AffectGlobalInformationGroup(result);
        this.calculatorService.Collaborateurs = result.Collaborateurs;
        this.calculatorService.LinkedMissions[index].loadingDatas = false;
        this.calculatorService.lockTabs = false;
        this.calculatorService.Amount += result.Mission.Amount;
        this.calculatorService.Discount += result.Mission.Discount;
        this.calculatorService.Mission = result.Mission;
        //this.calculatorService.AffectRequiredMissionProperties(this.calculatorService.LinkedMissions[index]);
        return { mission: result, index: index };
      }))
  }

  private AffectGlobalInformationGroup(calculator: ActionCoCalculatorModel): ActionCoCalculatorModel {
    let result: ActionCoCalculatorModel = calculator;

    if (!result.Mission.globalInformationGroup)
      result.Mission.globalInformationGroup = new ActionCoMissionGroup();
    result.Mission.globalInformationGroup.Label = 'Informations Générales';
    result.Mission.globalInformationGroup.Description = 'Liste des propriétés obligatoires';
    result.Mission.globalInformationGroup.Visible = true;
    result.Mission.globalInformationGroup.Questions = new Array<ActionCoMissionQuestion>();
    const question = new ActionCoMissionQuestion();
    question.Label = '';
    question.ShowCalculQuestion = true;
    question.Description = '';
    result.Mission.globalInformationGroup.Questions.push(JSON.parse(JSON.stringify(question)));
    question.Label = 'Obligations manuelles';
    question.Description = 'Obligations générées manuellement';
    result.Mission.globalInformationGroup.Questions.push(JSON.parse(JSON.stringify(question)));
    question.Label = 'Obligations automatiques';
    question.Description = 'Obligations générées depuis le plan de charge mais non rattachées à une question';
    result.Mission.globalInformationGroup.Questions.push(JSON.parse(JSON.stringify(question)));

    if (result && result.Obligations) {
      result.Mission.globalInformationGroup.Questions[1].Obligations = new Array<ActionCoMissionPDCGrouped>();
      result.Mission.globalInformationGroup.Questions[2].Obligations = new Array<ActionCoMissionPDCGrouped>();
      result.Obligations.forEach((obligation: ActionCoMissionPDCGrouped) => {
        if (obligation.Code.startsWith('X-')) {
          obligation.isPdc = true;
          (obligation as any).Deletable = true;
          result.Mission.globalInformationGroup.Questions[1].Obligations.push(obligation);
          result.Mission.globalInformationGroup.Questions[1].Amount += obligation.Amount;
        } else {
          result.Mission.globalInformationGroup.Questions[2].Obligations.push(obligation);
          result.Mission.globalInformationGroup.Questions[2].Amount += obligation.Amount;
        }
        result.Mission.globalInformationGroup.Questions[0].Amount += obligation.Amount;
      });
    }
    return result;
  }
}
